import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=06aabf07&"
import script from "./LoadMore.vue?vue&type=script&lang=ts&"
export * from "./LoadMore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports